import Vue from 'vue';
import collect from 'collect.js';
import axios from "axios";
import VueSweetalert2 from 'vue-sweetalert2';
import WeyaPagination from './components/weya-pagination';

import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);
Vue.component('weya-pagination', WeyaPagination);

axios.defaults.headers.common['X-Requested-With'] = "XMLHttpRequest";
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

const api = JSON.parse(document.getElementById('api').textContent);

function checkAgree(id) {
    return axios.post(api.agree, {id: id});
}

const downloadMixin = {
    methods: {
        eval: function (func) {
            eval(func);
        },
        changePage: function (page) {
            this.current = page;

            this.handleResults();
        },
        openNDA: function (row) {
            downloadModal.$data.row = row;
            checkAgree(row.id).then(() => {
                downloadModal.submit('wyForm');
            }).catch(() => {
                $('#downloadModal').modal('show');
            });
        },
        openDownload(link) {
            window.open(link, '_blank');
        },
        showLogin: function () {
            loginOpen();
        }
    }
};

const downloadModal = new Vue({
    el: "#downloadModal",
    data: {
        row: {},
        agree: true,
        onload: false
    },
    methods: {
        submit: function (form) {
            this.onload = true;
            if (this.row.level === "C") {
                const action = document.getElementById(form).action;

                axios.post(action, {id: this.row.id}).then(response => {
                    setTimeout(() => {
                        this.onload = false;
                        $('#downloadModal').modal('hide');
                        this.$swal({
                            icon: 'success',
                            text: response.data
                        });
                    }, 500);
                });
            } else {
                setTimeout(() => {
                    this.onload = false;
                    $('#downloadModal').modal('hide');
                    document.getElementById(form).submit();
                }, 500);
            }
        }
    }
});

const documents = new Vue({
    el: "#documents-center",
    data: {
        origin: [],
        solutions: [],
        types: [],
        products: [],
        solution: '',
        type: '',
        product: '',
        current: 1,
        results: [],
        counts: 0,
        size: 0
    },
    mounted() {
        this.origin = collect(api.categories);
        this.solutions = this.origin.flatMap(value => {
            return {'id': value.id, 'title': value.title};
        }).all();
        this.types = [];
        this.products = [];
        this.handleResults();
    },
    mixins: [downloadMixin],
    methods: {
        changeSolution: function () {
            this.type = '';
            this.product = '';
            this.current = 1;
            const types = this.origin.firstWhere('id', parseInt(this.solution));
            this.types = types !== null ? types.subs : [];
            this.products = [];

            this.handleResults();
        },
        changeType: function () {
            this.product = '';
            this.current = 1;
            const data = collect(this.types).firstWhere('id', parseInt(this.type));
            this.products = data.products !== null ? data.products : [];

            this.handleResults();
        },
        changeProduct: function () {
            this.current = 1;

            this.handleResults();
        },
        handleResults: function () {
            axios.post(api.link, {
                mode: 'documents',
                solution: this.solution,
                type: this.type,
                product: this.product,
                page: this.current
            }).then(response => {
                this.results = response.data.results;
                this.counts = response.data.counts;
                this.size = response.data.size;
            });
        }
    }
});

const others = new Vue({
    el: "#others",
    data: {
        current: 1,
        results: [],
        counts: 0,
        size: 0
    },
    mounted() {
        this.handleResults();
    },
    mixins: [downloadMixin],
    methods: {
        handleResults: function () {
            axios.post(api.link, {mode: 'others', page: this.current}).then(response => {
                this.results = response.data.results;
                this.counts = response.data.counts;
                this.size = response.data.size;
            });
        }
    }
});

$('#downloadModal').on('hidden.bs.modal', function (e) {
    downloadModal.$data.row = {};
});
